<style lang='less' scoped>
@import '../../../style/common/variable';
.newnational {display: flex;justify-content:space-between ;margin: 0;padding: 0;;margin-top: 15px;width: 774px;
  li {width: 79px;height: 113px;cursor: pointer;}
  .only {
    img {width: 79px;height: 113px;}
  }
  .pair {display: flex;flex-direction: column;justify-content: space-between;
    img {width: 79px;height: 52px;}
  }
}
@media screen and (max-width: @max-screen){
  .newnational{
    .only{display: flex; width: 20vw;}
    .pair{width: 20vw}
  }
}
</style>

<template>
  <ul class="newnational">
    <li class="pair">
      <img @click="goDmky(2)" class="Malaysia" src="../../../../static/index/flag/image_zg.png" alt="">
      <img @click="goDmky(13)" class="Indonesia" src="../../../../static/index/flag/image_ddw.png" alt="">
    </li>
    <li class="pair">
      <img @click="goDmky(4)" class="Malaysia" src="../../../../static/index/flag/image_mlxy.png" alt="">
      <img @click="goDmky(3)" class="Indonesia" src="../../../../static/index/flag/image_ydnxy.png" alt="">
    </li>
    <li class="pair">
      <img @click="goDmky(7)" class="Thailand" src="../../../../static/index/flag/image_tg.png" alt="">
      <img @click="goDmky(5)" class="Philippines" src="../../../../static/index/flag/image_flb.png" alt="">
    </li>
    <li class="pair">
      <img @click="goDmky(6)" class="Singapore" src="../../../../static/index/flag/image_xjp.png" alt="">
      <img @click="goDmky(8)" class="Brunei" src="../../../../static/index/flag/image_wl.png" alt="">
    </li>
    <li class="pair">
      <img @click="goDmky(9)" class="Vietnam" src="../../../../static/index/flag/image_yn.png" alt="">
      <img @click="goDmky(10)" class="Laos" src="../../../../static/index/flag/image_lw.png" alt="">
    </li>
    <li class="pair">
      <img @click="goDmky(11)" class="Myanmar" src="../../../../static/index/flag/image_md.png" alt="">
      <img @click="goDmky(12)" class="Cambodia" src="../../../../static/index/flag/image_jpz.png" alt="">
    </li>
  </ul>
</template>

<script>
export default {
  name: '',
  data()
  {
    return {
    }
  },
  methods: {
    goDmky(id)
    {
      let url = this.$router.resolve({path: '/Dmky', query: {id: id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/NewNational.vue